import OBase from './OBase';
import * as Geometry from '../geometry';

export default class EExplode extends OBase {
  update () {
    let sTree = this.getSurfaceObjectInput('S');
    let sGraftTree = this.graft(sTree);
    let output = this.getGenericObjectOutput('V');

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < sGraftTree.branches.length; i++) {
      for (let j = 0; j < sGraftTree.branches[i].length; j++) {
        let paths = sGraftTree.branches[i][j];

        for (let n = 0; n < paths.length; n++) {
          let path = paths[n];

          for (let m = 0; m < path.length; m++) {
            var pt = path[m];
            let newpt = new THREE.Vector3(pt.X, pt.Y, 0);
            outTree.add(newpt, sGraftTree.paths[i]);
          }
        }
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EExplode.js